<template>
  <div class="alert">
    <dotcom-icon
      name="circle-info"
      art="light"
      color="--c-secondary-neutral-2"
      hover-color="--c-secondary-neutral-2"
    />
    <div class="alert-content">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertMessage',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="postcss" scoped>
.alert {
  display: flex;
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 5px;
  flex-shrink: 1;
  flex-grow: 1;
  flex-basis: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 15px;
  line-height: 1.35;
  color: var(--c-primary-neutral-1);
  background-color: var(--c-primary-neutral-2);

  &-content {
    margin: auto 0;
  }

  & >>> .dotcom-icon {
    font-size: 24px;
    margin-right: 5px;
  }
}

@media (--md) {
  .alert {
    font-size: 13px;
  }
}
</style>
